/**
 * NS Collection Products Web Component
 * 封装 collection products 功能为自定义标签
 * 支持多个组件实例，每个实例独立管理自己的状态
 */
(function() {
  'use strict';

  class NSCollectionProducts extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.allProducts = [];
      this.visibleCount = 6;
      this.totalProducts = 0;
      this.loadMoreButton = null;
      this.boundHandlers = new WeakMap();
    }

    connectedCallback() {
      // 使用 requestAnimationFrame 确保 DOM 已完全渲染
      requestAnimationFrame(() => {
        this.init();
      });
    }

    init() {
      // 获取section ID
      this.sectionId = this.getAttribute('data-section-id');
      if (!this.sectionId) return;

      // 初始化PC端Swiper
      this.initSwiper();

      // 初始化移动端Load More功能
      this.initLoadMore();

      // 初始化图片悬浮切换功能
      this.initImageHover();
    }

    initSwiper() {
      const carousel = this.querySelector('#products-carousel-' + this.sectionId);
      if (carousel && typeof Swiper !== 'undefined') {
        this.swiper = new Swiper('#products-carousel-' + this.sectionId, {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 20,
          navigation: {
            nextEl: '#products-carousel-' + this.sectionId + ' .ns-collection-products__nav--next',
            prevEl: '#products-carousel-' + this.sectionId + ' .ns-collection-products__nav--prev',
          }
        });
      }
    }

    initLoadMore() {
      const loadMoreBtn = this.querySelector('#load-more-' + this.sectionId);
      const viewMoreBtn = this.querySelector('#view-more-' + this.sectionId);
      const mobileProducts = this.querySelector('#products-mobile-' + this.sectionId);
      
      if (!mobileProducts) return;

      this.allProducts = Array.from(mobileProducts.querySelectorAll('.ns-collection-products__product-mobile'));
      this.totalProducts = this.allProducts.length;
      
      // 如果产品数量少于等于6个，隐藏load more按钮, 显示view more按钮
      if (this.totalProducts <= 6) {
        if (loadMoreBtn) {
          loadMoreBtn.style.display = 'none';
        }
        if (viewMoreBtn) {
          viewMoreBtn.style.display = 'block';
        }
        return;
      }
      
      if (loadMoreBtn) {
        this.loadMoreButton = loadMoreBtn.querySelector('.ns-collection-products__load-more-btn');
        
        if (this.loadMoreButton) {
          // 为按钮创建绑定的事件处理器
          const handler = (e) => this.handleLoadMore(e);
          this.boundHandlers.set(this.loadMoreButton, handler);
          this.loadMoreButton.addEventListener('click', handler);
        }
      }
    }

    handleLoadMore(event) {
      // 显示接下来的6个产品
      const nextCount = Math.min(this.visibleCount + 6, this.totalProducts);
      for (let i = this.visibleCount; i < nextCount; i++) {
        if (this.allProducts[i]) {
          this.allProducts[i].style.display = 'block';
        }
      }
      
      this.visibleCount = nextCount;
      
      // 如果已经显示了超过6个或更多，隐藏load more按钮，显示view more按钮
      const loadMoreBtn = this.querySelector('#load-more-' + this.sectionId);
      const viewMoreBtn = this.querySelector('#view-more-' + this.sectionId);
      
      if (this.visibleCount > 6) {
        if (loadMoreBtn) {
          loadMoreBtn.style.display = 'none';
        }
        if (viewMoreBtn) {
          viewMoreBtn.style.display = 'block';
        }
      } else if (this.visibleCount >= this.totalProducts) {
        // 如果所有产品都已显示，隐藏load more按钮
        if (loadMoreBtn) {
          loadMoreBtn.style.display = 'none';
        }
      }
    }

    initImageHover() {
      const productImages = this.querySelectorAll('#products-carousel-' + this.sectionId + ' .ns-collection-products__product-image-hover');
      
      productImages.forEach((img) => {
        const hoverImageData = img.getAttribute('data-image');
        if (!hoverImageData) return;

        try {
          const imageData = JSON.parse(hoverImageData);
          if (imageData && Array.isArray(imageData) && imageData.length > 1) {
            const hoverSrc = imageData[1].src || imageData[1];
            if (hoverSrc) {
              // 检查formatImage函数是否存在
              if (typeof formatImage === 'function') {
                img.src = formatImage(hoverSrc, 600, 600);
              } else {
                img.src = hoverSrc;
              }
            }
          } else if (typeof imageData === 'string') {
            img.src = imageData;
          }
        } catch (e) {
          // 如果解析失败，尝试直接使用 hoverImageData 作为 URL
          if (hoverImageData && hoverImageData.trim() !== '' && hoverImageData !== 'null') {
            img.src = hoverImageData;
          }
        }
      });
    }

    disconnectedCallback() {
      // 清理事件监听器
      if (this.loadMoreButton) {
        const handler = this.boundHandlers.get(this.loadMoreButton);
        if (handler) {
          this.loadMoreButton.removeEventListener('click', handler);
        }
      }
      
      // 销毁Swiper实例
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
      }
      
      // 清理引用
      this.swiper = null;
      this.allProducts = [];
      this.loadMoreButton = null;
      this.boundHandlers = new WeakMap();
    }
  }

  // 立即注册自定义元素，确保在 DOM 渲染前可用
  if (typeof customElements !== 'undefined' && !customElements.get('ns-collection-products')) {
    customElements.define('ns-collection-products', NSCollectionProducts);
  } else if (typeof customElements === 'undefined') {
    // 如果 customElements 未定义，等待其可用后再注册
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        if (!customElements.get('ns-collection-products')) {
          customElements.define('ns-collection-products', NSCollectionProducts);
        }
      });
    } else {
      // DOM 已加载，但 customElements 可能还未定义，稍后重试
      setTimeout(function() {
        if (typeof customElements !== 'undefined' && !customElements.get('ns-collection-products')) {
          customElements.define('ns-collection-products', NSCollectionProducts);
        }
      }, 0);
    }
  }
})();

